export default {
  firstName: {
    id: 'address_book_create_first_name',
    defaultMessage: 'Recipient first name',
  },
  lastName: {
    id: 'address_book_create_last_name',
    defaultMessage: 'Recipient last name',
  },
  company: {
    id: 'address_book_create_company',
    defaultMessage: 'Company',
  },
  street: {
    id: 'address_book_create_street_address',
    defaultMessage: 'Street address',
  },
  streetSupplement: {
    id: 'address_book_create_street_address_supplement',
    defaultMessage: 'Street address (optional)',
  },
  postalCode: {
    id: 'address_book_create_postal_code',
    defaultMessage: 'Postal Code',
  },
  city: {
    id: 'address_book_create_city',
    defaultMessage: 'City',
  },
  country: {
    id: 'address_book_create_country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'address_book_state',
    defaultMessage: 'State',
  },
  phoneNumber: {
    id: 'address_book_create_phone',
    defaultMessage: 'Phone number',
  },
  phoneNumberDescription: {
    id: 'address_book_create_phone_description',
    defaultMessage:
      'You have to enter your phone number with its dedicated country code.',
  },
  label: {
    id: 'address_book_create_name',
    defaultMessage: 'Address name',
  },
  labelDescription: {
    id: 'address_book_create_name_description',
    defaultMessage: 'This name will be displayed in the addresses list.',
  },
  create: {
    id: 'address_book_create_new_address',
    defaultMessage: 'Create a new address',
  },
  save: {
    id: 'address_book_edit_address',
    defaultMessage: 'Save',
  },
  required: {
    id: 'address_book_create_required',
    defaultMessage: 'This field is required',
  },
}
